<script>
  import MenuHeading from "../shared/MenuHeading.svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import config from "../stores/config";
  import * as ls from "local-storage";

  let username;
  let password;
  let loading = false;

  const handleLogin = () => {
    loading = true;

    axios
      .post(`${$config.backendURL}/login`, {
        username: username.trim(),
        password: password.trim(),
      })
      .then((res) => {
        loading = false;
        ls.set("jwt", res.data.token);
        if (res.data.error) {
          console.log(err);
          alert(res.data.error);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          window.location = "/#/orders";
        }
      })
      .catch((err) => {
        loading = false;
        console.log(err);
        alert("The username or password entered was not correct!");
        window.location = "/#/login";
      });
  };
</script>

<svelte:head>
  <title>Login — Supreme Upholstery System</title>
</svelte:head>

<div class="h-screen w-full" style="background-color: #FAFAFA;">
  <div
    class="h-screen w-full p-5 flex items-center justify-center"
    style="background-image: url(./images/pattern.svg)"
  >
    <div
      class="flex flex-col justify-center items-center bg-white shadow-xl rounded-xl border border-gray-200 px-10 pb-4"
    >
      <div class="flex flex-col items-center justify-center">
        <MenuHeading
          title="Supreme Upholstery System"
          description="To access the dashboard, please login your username and password"
        />
      </div>
      <form
        on:submit|preventDefault={handleLogin}
        class="mt-2 grid grid-cols-1"
        style="width: 32rem;"
      >
        <input
          type="text"
          placeholder="Username"
          class="mb-4 shadow-sm"
          bind:value={username}
        />
        <input
          type="password"
          placeholder="Password"
          class="mb-4 shadow-sm"
          bind:value={password}
        />
        {#if loading}
          <button disabled class="mb-4 btn btn-primary animate-pulse">
            Loggin in...
          </button>
        {:else}
          <button class="mb-4 btn btn-primary">
            Login
            <i class="fas fa-arrow-alt-circle-right ml-3" />
          </button>
        {/if}
      </form>
    </div>
  </div>
</div>
